const formState = [
    {
        units: 'ft',
        area: 0,
        length: 0,
        width: 0,
        isThereSubstruct: true
    },
    {
        selectedVariant: '',
        variantPriceMin: 0,
        variantPriceMax: 0,
    },
    {
        selectedRailing: '',
        railingPriceMin: 0,
        railingPriceMax: 0
    }
];

// Navigation Buttons and Screens ---
const navNumerals = [
    document.getElementById('top-step-1'),
    document.getElementById('top-step-2'),
    document.getElementById('top-step-3'),
    document.getElementById('top-step-4'),

]

const nextBtns = [
    document.getElementById('step1-continue-button'),
    document.getElementById('step2-continue-button'),
    document.getElementById('get-results-button')
]

const backBtns = [
    document.getElementById('step2-go-back-button'),
    document.getElementById('step3-go-back-button')
]

const nav = {
    activeDisplay: document.getElementById('active-display'),
    steps: [
        document.getElementById('step-1-size'),
        document.getElementById('step-2-decking'),
        document.getElementById('step-3-railing'),
        document.getElementById('results')
    ]

};

//Step-1 Elements
const sizeElems = {
    radioBtns: document.querySelectorAll('input[name=unit]'),
    unitLabel: document.querySelectorAll('.unit-label'),
    lengthInput: document.getElementById('length-input'),
    widthInput: document.getElementById('width-input'),
    toggleButtonSizes: document.getElementById('toggle-button-sizes'),
    commonSizesFt: document.getElementById('common-sizes--ft'),
    commonSizesMt: document.getElementById('common-sizes--mt'),
    toggleButtonImage: document.getElementById('toggle-button-image'),
    substructureExist: document.getElementById('substructure-exist'),
    substructurePriceSqFt: document.getElementById('substructure-price-sqft'),
    deckingImgBox: document.getElementById('step-1-decking-image'),
    totalArea: document.querySelectorAll('.total-area'),
    deckingImages: document.querySelectorAll('.calculator--image.step-1'),
}

const commonDeckSizes = [
    { id: '8_8', area: 8 * 8 },
    { id: '10_10', area: 10 * 10 },
    { id: '12_12', area: 12 * 12 },
    { id: '12_14', area: 12 * 14 },
    { id: '12_16', area: 12 * 16 },
    { id: '12_18', area: 12 * 18 },
    { id: '12_20', area: 12 * 20 },
    { id: '14_20', area: 14 * 20 },
    { id: '16_14', area: 16 * 14 },
    { id: '16_16', area: 16 * 16 },
    { id: '16_18', area: 16 * 18 },
    { id: '16_20', area: 16 * 20 },
    { id: '16_24', area: 16 * 24 },
    { id: '18_20', area: 18 * 20 },
    { id: '20_20', area: 20 * 20 }
];

//Step-2 Elements
const deckingElems = {
    cardsContainer: document.querySelector('#step-2-decking .products-scroll-inner'),
    featuredImages: document.querySelectorAll('.calculator--image.step-2'),
    arrayOfCards: document.querySelectorAll('#step-2-decking product-card')
}

//Step-3 Elements
const railingElems = {
    cardsContainer: document.querySelector('#step-3-railing .products-scroll-inner'),
    featuredImages: document.querySelectorAll('.calculator--image.step-3'),
    noRailingImage: document.querySelector('.calculator--image.step-3.no-railing'),
    arrayOfCards: document.querySelectorAll('#step-3-railing .product-card-radio--wrapper'),
    categoryTags: document.querySelectorAll('.railing-tag')
}

//Resuts Elements
const resultElems = {
    featuredImages: document.querySelectorAll('.calculator--image.results'),
    priceText: document.getElementById('price-range'),
    sizeText: document.getElementById('size-result'),
    isThereSubstrctText: document.getElementById('substructure-result'),
    deckingText: document.getElementById('decking-result'),
    railingText: document.getElementById('railing-result'),
    toggleEditSelections: document.getElementById('toggle-button-results'),
    editButtonsContainer: document.getElementById('edit-result-buttons'),
    shopTheSamples: document.getElementById('resutls-shop-samples'),
    getDetailedCostButton: document.getElementById('resutls-send-email')
}

//Form element
const hubSpotFormSection = document.getElementById('cost_calculator_contact_form');
if (hubSpotFormSection) {
    hubSpotFormSection.hidden = true;
}

let resultFeaturedImageIndex = 0;

// Initial Listeners and Navigation Logic --
let sizeListenersAdded = false;
let deckingListenersAdded = false;
let railingListenersAdded = false;
let colorListenersAdded = false;
let addOnsListenersAdded = false;
let resultsListenersAdded = false;

nextBtns.forEach((button, index) => {
    button.addEventListener('click', () => handleContinue(index));
})

backBtns.forEach((button, index) => {
    button.addEventListener('click', () => handleGoBack(index));
})

navNumerals.forEach((numeral, index) => {
    numeral.addEventListener('click', () => handleNumeralNav(numeral, index))
})

function handleNumeralNav(navNumeral, sectionIndex) {
    if (navNumeral.classList.contains('completed')) {
        showSection(sectionIndex);
        updateNavNumerals(sectionIndex);
    }

}

function handleContinue(buttonIndex) {
    switch (buttonIndex) {
        case 0:
            initializeDeckVariantSection();
            break;
        case 1:
            initializeRailingSection();
            break;
        case 2:
            initializeResultSection();

    }
}

function handleGoBack(buttonIndex) {
    switch (buttonIndex) {
        case 0:
            initializeSizeSection();
            break;
        case 1:
            initializeDeckVariantSection();
            break;
        case 2:
            initializeRailingSection();
    }
}

function showSection(index) {
    if (hubSpotFormSection) {
        hubSpotFormSection.hidden = true;
    }
    nav.activeDisplay.innerHTML = '';
    nav.activeDisplay.appendChild(nav.steps[index]);
    document.querySelector('.section-header').scrollIntoView({ behavior: "smooth" });
}

function updateFormState(index, updates) {
    formState[index] = { ...formState[index], ...updates }
}

function updateNavNumerals(sectionNumber) {

    navNumerals.forEach((numeral, index) => {
        numeral.classList.remove('active', 'completed', 'disabled');
        if (index < sectionNumber) {
            numeral.classList.add('completed');
        } else if (index === sectionNumber) {
            numeral.classList.add('active');
        } else {
            numeral.classList.add('disabled');
        }
    });
}

// Step-1: Dimensions
function initializeSizeSection() {

    const sectionIndex = 0;
    let existentStruct;
    let selectedUnit;
    showSection(sectionIndex);
    updateNavNumerals(sectionIndex);

    if (!sizeListenersAdded) {
        sizeElems.radioBtns.forEach(button => button.addEventListener('change', handleUnitToggle));
        sizeElems.lengthInput.addEventListener('input', handleNumberInput);
        sizeElems.widthInput.addEventListener('input', handleNumberInput);
        sizeElems.toggleButtonSizes.addEventListener('click', handleDropChange);
        sizeElems.toggleButtonImage.addEventListener('click', handleDropChange);
        sizeElems.commonSizesFt.addEventListener('click', handleSizeSelection);
        sizeElems.commonSizesMt.addEventListener('click', handleSizeSelection);
        sizeElems.substructureExist.addEventListener('click', handleSubstructureRadio);
        selectedUnit = 'ft';
        existentStruct = true;
        sizeListenersAdded = true;
    }
    setDeckDimensions();

    function handleNumberInput(event) {

        const input = event.target;
        formatNumberInput(input);
        deactivateCommonSizes();
    }

    function formatNumberInput(input) {
        input.value = input.value.replace(/[^0-9]/g, '').replace(/^0+/, '') || '0';
        handleZeroInput(input);
    }

    function handleZeroInput(input) {

        const errorMessage = input.closest('.field').querySelector('.error-message');
        if (input.value === '0') {
            input.classList.add('input-error');
            errorMessage.classList.add('active');
            // disableContinueButton();
        } else {
            clearErrorDisplay();
            displayDeckImage();
        }
    }

    function handleUnitToggle(event) {

        const isFtUnits = event.target.id === 'toggle-ft';
        selectedUnit = event.target.id === 'toggle-ft' ? 'ft' : 'm';
        sizeElems.unitLabel.forEach(label => label.innerHTML = selectedUnit + '.');

        if (isFtUnits) {
            sizeElems.commonSizesFt.classList.remove('hidden');
            sizeElems.commonSizesMt.classList.add('hidden');
            sizeElems.lengthInput.value = 12;
            sizeElems.widthInput.value = 12;
        } else {
            sizeElems.commonSizesFt.classList.add('hidden');
            sizeElems.commonSizesMt.classList.remove('hidden');
            sizeElems.lengthInput.value = 3;
            sizeElems.widthInput.value = 3;
        }
        resetSelectedSize(selectedUnit);
        clearErrorDisplay();
    }

    function handleDropChange(event) {
        const elementToToggleIds = event.target.getAttribute('data-toggle-target');
        const elementToToggle = document.getElementById(elementToToggleIds);
        if (!elementToToggle) return;
        const isVisible = elementToToggle.classList.contains('active');
        elementToToggle.classList.toggle('active', !isVisible);
        if (elementToToggle.classList.contains('image-toggle-block')) {
            elementToToggle.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
            });
        }
    }

    function handleSizeSelection(event) {

        if (event.target.classList.contains('common-size')) {

            event.currentTarget.querySelectorAll('.common-size').forEach(btn => btn.classList.remove('active'));
            event.target.classList.add('active');
            sizeElems.widthInput.value = event.target.getAttribute('data-width');
            sizeElems.lengthInput.value = event.target.getAttribute('data-length');
            displayDeckImage();
            clearErrorDisplay();
        }
    }

    function resetSelectedSize(unit) {

        const container = unit === 'ft.' ? sizeElems.commonSizesFt : sizeElems.commonSizesMt;
        container.querySelectorAll('.common-size').forEach(btn => btn.classList.remove('active'));

        const firstButton = container.querySelector('.common-size');
        if (firstButton) {
            firstButton.classList.add('active');
        }
        displayDeckImage();
    }

    function deactivateCommonSizes() {
        document.querySelectorAll('.common-size').forEach(btn => btn.classList.remove('active'));
    }

    function clearErrorDisplay() {

        document.querySelectorAll('.error-message').forEach(errorMessage => {
            if (errorMessage.classList.contains('active')) {
                errorMessage.classList.remove('active');
                sizeElems.lengthInput.classList.remove('input-error');
                sizeElems.widthInput.classList.remove('input-error');
            }
        });
        enableContinueButton();
    }

    function enableContinueButton() {
        nextBtns[sectionIndex].classList.remove('disabled');
    }

    function handleSubstructureRadio(event) {

        if (event.target.classList.contains('substructure-tag')) {
            document.querySelectorAll('.substructure-tag').forEach(tag => tag.classList.remove('active'))
            event.target.classList.add('active');
            existentStruct = event.target.textContent === "Yes" ? true : false;
            setDeckDimensions();

        }
    }

    function displayDeckImage() {
        const [closesSizeID, area, units] = getClosestCommonSizeArea();
        sizeElems.deckingImages.forEach(image => image.style.display = 'none');
        const matchingImage = document.querySelector(`#step-1-size .calculator--image[data-size="${closesSizeID}"]`);
        if (matchingImage) matchingImage.style.display = 'block';
        displayTotalArea(area, units)
        setDeckDimensions();
    }

    function displayTotalArea(totalArea, units) {
        const visibleFeaturedImage = Array.from(sizeElems.deckingImages).find(
            element => window.getComputedStyle(element).display === 'block'
        );
        const convertionArea = units === 'ft' ? 1 : 10.76;
        visibleFeaturedImage.querySelector('.total-area-value').textContent = totalArea/convertionArea;
        visibleFeaturedImage.querySelector('.area-units').firstChild.textContent = units;
    }

    function getClosestCommonSizeArea() {

        const [area, units] = calculateUserArea();
        let closestMatch = commonDeckSizes[0];
        commonDeckSizes.forEach(commonSize => {
            if (Math.abs(commonSize.area - area) < Math.abs(closestMatch.area - area)) {
                closestMatch = commonSize;
            }
        })
        return [closestMatch.id, area, units]
    }

    function calculateUserArea() {
        const width = parseFloat(sizeElems.widthInput.value) || 0;
        const length = parseFloat(sizeElems.lengthInput.value) || 0;
        const areaConvertionFactor = document.querySelector('input[name="unit"]:checked').id === 'toggle-ft' ? 1 : 10.76;
        let area = width * length * areaConvertionFactor;
        const units = sizeElems.commonSizesFt.classList.contains('hidden') ? 'm' : 'ft';
        return [area, units]
    }

    function setDeckDimensions() {
        const newSizeData = {
            units: selectedUnit,
            area: sizeElems.lengthInput.value * sizeElems.widthInput.value,
            length: parseFloat(sizeElems.widthInput.value),
            width: parseFloat(sizeElems.lengthInput.value),
            isThereSubstruct: existentStruct
        };
        updateFormState(sectionIndex, newSizeData);
    }


}

// Step-2: Decking Style
function initializeDeckVariantSection() {

    const sectionIndex = 1;
    let deckSelection;
    let deckPricingMin;
    let deckPricingMax;

    showSection(sectionIndex);
    updateNavNumerals(sectionIndex);
    setDeckSelection();
    setDefaultValues();

    if (!deckingListenersAdded) {
        if (deckingElems.cardsContainer) deckingElems.cardsContainer.addEventListener('click', handleCardSelection);
        deckingListenersAdded = true;
    }

    function setDefaultValues() {
        deckingElems.arrayOfCards.forEach(card => {
            if (card.classList.contains('selected')) {
                deckSelection = card.querySelector('.product-card-title').textContent;
                deckPricingMin = card.getAttribute('data-product-pricing-min');
                deckPricingMax = card.getAttribute('data-product-pricing-max');
            }
        })
        setDeckSelection();
    }

    function handleCardSelection(event) {
        const selectedCard = event.target.closest('product-card');

        if (selectedCard) {

            document.querySelectorAll('product-card').forEach(card => card.classList.remove('selected'));
            selectedCard.classList.add('selected');

            deckPricingMin = selectedCard.getAttribute('data-product-pricing-min') || 0;
            deckPricingMax = selectedCard.getAttribute('data-product-pricing-max') || 0;
            deckSelection = selectedCard.querySelector('.product-card-title').textContent;

            displayFeaturedImage(selectedCard)
            setDeckSelection();
        }
    }

    function displayFeaturedImage(card) {

        deckingElems.featuredImages.forEach(image => image.style.display = 'none');
        const selectedIndex = Array.from(document.querySelectorAll('product-card')).indexOf(card);
        resultFeaturedImageIndex = selectedIndex;
        const imageToDisplay = Array.from(deckingElems.featuredImages)[selectedIndex];
        imageToDisplay.style.display = 'block';
    }

    function setDeckSelection() {

        deckPricingMin = isNaN(Number(deckPricingMin)) ? 0 : Number(deckPricingMin);
        deckPricingMax = isNaN(Number(deckPricingMax)) ? 0 : Number(deckPricingMax);
        const newDeckingData = {
            selectedVariant: deckSelection,
            variantPriceMin: parseFloat(deckPricingMin),
            variantPriceMax: parseFloat(deckPricingMax)
        };
        updateFormState(sectionIndex, newDeckingData);
    }
}

// Step-3: Railing Style
function initializeRailingSection() {

    const sectionIndex = 2;
    let railingSelection;
    let railingPricingMin;
    let railingPricingMax;

    showSection(sectionIndex);
    updateNavNumerals(sectionIndex);
    setRailingSelection();
    filterRailingCards();

    if (!railingListenersAdded) {
        if (railingElems.cardsContainer) railingElems.cardsContainer.addEventListener('click', handleCardSelection);
        railingListenersAdded = true;
    }

    function filterRailingCards() {
        const initialSelectedRailing = document.querySelector('.railing-tag.active').id;
        showMatchingCards(initialSelectedRailing);


        railingElems.categoryTags.forEach(tag => {
            tag.addEventListener('click', (event) => {
                document.querySelectorAll('.railing-tag').forEach(tag => tag.classList.remove('active'));
                event.target.classList.add('active');
                showMatchingCards(event.target.id);
            });
        });

    }

    function showMatchingCards(selectedRailing) {
        let firstMatch = true;
        let matchFound = false;
        resetCards(railingElems.arrayOfCards);

        // Get the filter tag from the button
        const filterTag = document.querySelector(`#${selectedRailing}`).getAttribute('data-filter-tag');

        railingElems.arrayOfCards.forEach(card => {
            const productTags = card.querySelector('product-card').getAttribute('data-product-tags');

            // Handle no-railing case: don't show any products
            if (selectedRailing === 'no-railing') {
                // Skip showing any products for no-railing
                return;
            }

            // Check if product has matching tag for actual railing types
            const hasMatchingTag = filterTag && productTags && productTags.includes(filterTag);

            if (hasMatchingTag) {
                card.classList.remove('hidden');

                if (firstMatch) {

                    railingElems.featuredImages.forEach(image => image.style.display = 'none');
                    const selectedIndex = Array.from(railingElems.arrayOfCards).indexOf(card);
                    const imageToDisplay = Array.from(railingElems.featuredImages)[selectedIndex];
                    imageToDisplay.style.display = 'block';

                    card.querySelector('product-card').classList.add('selected');
                    railingPricingMin = card.querySelector('product-card').getAttribute('data-product-pricing-min');
                    railingPricingMax = card.querySelector('product-card').getAttribute('data-product-pricing-max');
                    railingSelection = card.querySelector('product-card').querySelector('.product-card-title').textContent;

                    firstMatch = false;
                    matchFound = true;
                }
            }

        });

        handleNoMatches(matchFound);
        setRailingSelection();
    }

    function resetCards(cards) {
        cards.forEach(card => {
            card.classList.add('hidden');
            card.querySelector('product-card').classList.remove('selected');
        });
    }

    function handleNoMatches(matchFound) {
        if (!matchFound) {
            railingPricingMin = 0;
            railingPricingMax = 0;
            railingSelection = 'No Railing Selected';

            const selectedRailing = document.querySelector('.railing-tag.active').id;
            if (selectedRailing === 'no-railing') {
                railingElems.featuredImages.forEach(image => image.style.display = 'none');
                railingElems.noRailingImage.style.display = 'block';
            }
        }
    }

    function handleCardSelection(event) {
        const selectedCard = event.target.closest('product-card');

        if (selectedCard) {

            document.querySelectorAll('#step-3-railing product-card').forEach(card => card.classList.remove('selected'));
            selectedCard.classList.add('selected');
            railingPricingMin = selectedCard.getAttribute('data-product-pricing-min');
            railingPricingMax = selectedCard.getAttribute('data-product-pricing-max');
            railingSelection = selectedCard.querySelector('.product-card-title').textContent;

            railingElems.featuredImages.forEach(image => image.style.display = 'none');
            const selectedIndex = Array.from(railingElems.arrayOfCards).indexOf(selectedCard.parentElement);
            const imageToDisplay = Array.from(railingElems.featuredImages)[selectedIndex];
            imageToDisplay.style.display = 'block';

            setRailingSelection();
        }
    }

    function setRailingSelection() {
        railingPricingMin = isNaN(Number(railingPricingMin)) ? 0 : Number(railingPricingMin);
        railingPricingMax = isNaN(Number(railingPricingMax)) ? 0 : Number(railingPricingMax);
        const newDeckingData = {
            selectedRailing: railingSelection,
            railingPriceMin: parseFloat(railingPricingMin),
            railingPriceMax: parseFloat(railingPricingMax)

        };
        updateFormState(sectionIndex, newDeckingData);
    }
}

function initializeResultSection() {
    const sectionIndex = 3;
    showSection(sectionIndex);
    updateNavNumerals(sectionIndex);
    setResultsFeaturedImage();
    setResultsValues();

    if (!resultsListenersAdded) {
        resultElems.editButtonsContainer.addEventListener('click', handleEditButtonClick);
        resultElems.getDetailedCostButton.addEventListener('click', displayHubSpotForm)
        resultsListenersAdded = true;
    }

    function handleEditButtonClick(event) {
        if (event.target.classList.contains('edit-button')) {
            const clickedButton = event.target.closest('.results-text').id;

            switch (clickedButton) {
                case 'size-result':
                    initializeSizeSection();

                    break;
                case 'substructure-result':
                    initializeSizeSection();
                    break;
                case 'decking-result':
                    initializeDeckVariantSection();
                    break;
                case 'railing-result':
                    initializeRailingSection();
                    break;

            }
        }
    }

    function setResultsFeaturedImage() {

        resultElems.featuredImages.forEach(image => image.style.display = 'none');
        const imageToDisplay = Array.from(resultElems.featuredImages)[resultFeaturedImageIndex];
        imageToDisplay.style.display = 'block';
    }

    function setResultsValues() {
        const units = formState[0].units === 'ft' ? "'" : 'm';
        const cleanText = text => text.replace(/"/g, '');
        const result = getCalculations();
        const minCostToPriceFormat = result.totalMinCost.toLocaleString('en-US');
        const maxCostToPriceFormat = result.totalMaxCost.toLocaleString('en-US');
        resultElems.priceText.textContent = `$${minCostToPriceFormat} - $${maxCostToPriceFormat}`;
        resultElems.sizeText.childNodes[2].textContent = `${formState[0].length + units} x ${formState[0].width + units}`;
        resultElems.isThereSubstrctText.firstChild.textContent = formState[0].isThereSubstruct ? 'Using Existing Substructure' : 'New Substructure Required';
        resultElems.deckingText.childNodes[2].textContent = cleanText(formState[1].selectedVariant ? `${formState[1].selectedVariant}` : 'No Decking');
        resultElems.railingText.childNodes[2].textContent = cleanText(formState[2].selectedRailing || 'No Railing Selected');
    }

    function getCalculations() {

        let substructureCost = 0;
        let deckingMinCost = 0;
        let deckingMaxCost = 0;
        let railingMinCost = 0;
        let railingMaxCost = 0;
        let totalMinCost = 0;
        let totalMaxCost = 0;

        const { units, area, length, width, isThereSubstruct } = formState[0];
        const { variantPriceMin, variantPriceMax } = formState[1];
        const { railingPriceMin, railingPriceMax } = formState[2];

        const convertionAreaFactor = units === 'ft' ? 1 : 10.76;
        const convertionFactor = units === 'ft' ? 1 : 3.28;

        deckingMinCost = area * convertionAreaFactor * variantPriceMin;
        deckingMaxCost = area * convertionAreaFactor * variantPriceMax;

        totalMinCost += deckingMinCost;
        totalMaxCost += deckingMaxCost;

        if (!isThereSubstruct) {
            substructureCost = area * convertionAreaFactor * parseFloat(sizeElems.substructurePriceSqFt.getAttribute('data-substructure-price'));
            totalMinCost += substructureCost;
            totalMaxCost += substructureCost;
        }

        railingMinCost += ((length + width * 2) * convertionFactor) * railingPriceMin;
        railingMaxCost += ((length + width * 2) * convertionFactor) * railingPriceMax;

        totalMinCost += railingMinCost;
        totalMaxCost += railingMaxCost;

        const roundToNearest = (value, nearest) => Math.round(value / nearest) * nearest;

        return {
            totalMinCost: roundToNearest(totalMinCost, 100),
            totalMaxCost: roundToNearest(totalMaxCost, 100),
            substructureCost: roundToNearest(substructureCost, 100),
            deckingMinCost: roundToNearest(deckingMinCost, 100),
            deckingMaxCost: roundToNearest(deckingMaxCost, 100),
            railingMinCost: roundToNearest(railingMinCost, 100),
            railingMaxCost: roundToNearest(railingMaxCost, 100)
        };

    }

    function displayHubSpotForm() {
        hubSpotFormSection.hidden = false;
        hubSpotFormSection.scrollIntoView({ behavior: 'smooth' });

        const [dimensions, decking, railing] = formState;
        const { totalMinCost, totalMaxCost, substructureCost, deckingMinCost, deckingMaxCost, railingMinCost, railingMaxCost } = getCalculations();
        
        const formattedSubStructValue = substructureCost === 0 ? "N/A" : `$${substructureCost.toLocaleString('en-US')}`;
        const formattedRailingValue = (railingMinCost === 0 || railingMaxCost === 0) ? "N/A" :  `$${railingMinCost.toLocaleString('en-US')} - $${railingMaxCost.toLocaleString('en-US')}`;

        hubSpotFormSection.querySelector('input[name="decking_type"]').value = decking.selectedVariant;
        hubSpotFormSection.querySelector('input[name="railing_type"]').value = railing.selectedRailing;
        hubSpotFormSection.querySelector('input[name="existing_substructure"]').value = dimensions.isThereSubstruct ? "Using Existing Substructure" : "New Substructure Needed";
        hubSpotFormSection.querySelector('input[name="area"]').value = dimensions.area;
        hubSpotFormSection.querySelector('input[name="unit_system"]').value = dimensions.units;
        hubSpotFormSection.querySelector('input[name="substructure_cost"]').value = formattedSubStructValue;
        hubSpotFormSection.querySelector('input[name="decking_cost"]').value = `$${deckingMinCost.toLocaleString('en-US')} - $${deckingMaxCost.toLocaleString('en-US')}`;
        hubSpotFormSection.querySelector('input[name="railing_cost"]').value = formattedRailingValue;
        hubSpotFormSection.querySelector('input[name="total_cost"]').value = `$${totalMinCost.toLocaleString('en-US')} - $${totalMaxCost.toLocaleString('en-US')}`;

        // const hubSpotForm = hubSpotFormSection.querySelector('form');
        // const submitButton = hubSpotForm.querySelector('input[type="submit"]');
        // submitButton.addEventListener('click', submitForm);


        function submitForm(event) {
            event.preventDefault();
            const zipCode = hubSpotFormSection.querySelector('input[name="zip"]').value;

            fetchLocations(zipCode);

        }
        async function getCoordinates(zipCode) {
            const apiKey = 'c51ba6a1101546e8a36ee597cd70ccae';
            const url = `https://api.opencagedata.com/geocode/v1/json?q=${zipCode}&countrycode=us&limit=1&key=${apiKey}`;

            try {
                const response = await fetch(url);
                const data = await response.json();

                if (data.results.length > 0) {
                    const { lat, lng } = data.results[0].geometry;
                    return { lat, lng };
                } else {
                    throw new Error('No results found for the provided ZIP code');
                }

            } catch (error) {
                console.error('Error fetching coordinates:', error.message);
                throw error;
            }
        }

        async function getStorepointLocations(lat, lng) {
            const radius = 200;

            const urls = [
                `https://api.storepoint.co/v1/165045ce409224/locations?lat=${lat}&long=${lng}&radius=${radius}`,
                `https://api.storepoint.co/v1/165037799e393f/locations?lat=${lat}&long=${lng}&radius=${radius}`
            ];

            try {
                const responses = await Promise.all(urls.map(url => fetch(url)));

                responses.forEach(response => {
                    if (!response.ok) {
                        throw new Error(`Storepoint API error: ${response.status}`);
                    }
                });

                const data = await Promise.all(responses.map(response => response.json()));

                return data;

            } catch (error) {
                console.error('Error fetching Storepoint locations:', error.message);
                throw error;
            }
        }

        async function findLocationsByZip(zipCode) {
            try {
                const { lat, lng } = await getCoordinates(zipCode);
                console.log(`Coordinates for ${zipCode}: Latitude ${lat}, Longitude ${lng}`);

                const locations = await getStorepointLocations(lat, lng);

                return locations;

            } catch (error) {
                console.error('Error:', error.message);
                displayZipInputError();
                return null;
            }
        }

        function displayZipInputError() {
            const zipInput = hubSpotForm.querySelector('input[name="zip"]');
            zipInput.classList.add('invalid');
            zipInput.scrollIntoView({ behavior: 'smooth', block: 'center' })

            zipInput.insertAdjacentHTML('afterend', `
                <ul class="no-list hs-error-msgs inputs-list" role="alert" style="display: block;">
                    <li>
                        <label class="hs-error-msg hs-main-font-element">
                            Please enter a valid ZIP code.
                        </label>
                    </li>
                </ul>
            `);

            zipInput.addEventListener('focus', removeZipErrorMessage);
        }

        function removeZipErrorMessage() {
            const zipInput = hubSpotForm.querySelector('input[name="zip"]');
            if (!zipInput) return;

            const errorContainer = zipInput.parentElement.querySelector('.hs-error-msgs');
            if (errorContainer) {
                errorContainer.remove();
            }
            zipInput.classList.remove('invalid');
        }

        async function fetchLocations(zip) {
            try {
                const locations = await findLocationsByZip(zip);
                if (locations) {
                    const filteredContractors = extractContractorsInfo(locations[0]);
                    const filteredDealers = extractDealersInfo(locations[1]);
                    fillAndSubmitHubSpotForm(filteredContractors, filteredDealers)

                }

            } catch (err) {
                console.error('Failed to get locations:', err);
            }
        }

        function extractContractorsInfo(contractors) {

            const closestThreeContrarctors = contractors.results.locations.slice(0, 3);
            const extractedInfo = closestThreeContrarctors.map(contractor => ({
                name: contractor.name,
                address: contractor.streetaddress,
                phone: formatPhoneNumber(contractor.phone),
                email: cleanEmail(contractor.email),
                website: cleanUrl(contractor.website),
                distance: contractor.distance
            }))
            return extractedInfo;
        }

        function extractDealersInfo(dealers) {
            const closestThreeDealers = dealers.results.locations.slice(0, 3);
            const extractedInfo = closestThreeDealers.map(contractor => ({
                name: contractor.name,
                address: contractor.streetaddress,
                phone: formatPhoneNumber(contractor.phone),
                website: cleanUrl(contractor.website),
                distance: contractor.distance
            }))
            return extractedInfo;
        }

        function formatPhoneNumber(phone) {
            if (!phone.trim()) {
                return '';
            }

            const digits = phone.replace(/\D/g, '');

            return digits.length === 10 ? `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}` : '';
        }

        function cleanEmail(email) {
            return email ? email.replace(/^mailto:/, '').split('?')[0] : "";
        }

        function cleanUrl(url) {
            if (!url || typeof url !== 'string' || !url.startsWith('http')) {
                return '';
            }
            try {
                let formattedUrl = new URL(url);
                return formattedUrl.hostname.replace(/^www\./, '');
            } catch (error) {
                return '';
            }
        }

        function fillAndSubmitHubSpotForm(filteredContractors, filteredDealers) {

            if (!hubSpotForm) {
                console.error("HubSpot form not found in the DOM!");
                return;
            }

            function getValueOrPlaceholder(value) {
              
                if (value === null || value === undefined) {
                    return "";
                }
                
                return String(value).trim();
            }

            // Fill Contractor Fields
            filteredContractors.forEach((contractor, index) => {
                const contractorNum = index + 1;
                hubSpotFormSection.querySelector(`input[name="contractor_company_name_${contractorNum}"]`).value = getValueOrPlaceholder(contractor.name);
                hubSpotFormSection.querySelector(`input[name="contractor_address_${contractorNum}"]`).value = getValueOrPlaceholder(contractor.address);
                hubSpotFormSection.querySelector(`input[name="contractor_phone_${contractorNum}"]`).value = getValueOrPlaceholder(contractor.phone);
                hubSpotFormSection.querySelector(`input[name="contractor_email_${contractorNum}"]`).value = getValueOrPlaceholder(contractor.email);
                hubSpotFormSection.querySelector(`input[name="contractor_website_${contractorNum}"]`).value = getValueOrPlaceholder(contractor.website);
                hubSpotFormSection.querySelector(`input[name="contractor_distance_${contractorNum}"]`).value = getValueOrPlaceholder(contractor.distance);
            });

            // Fill Dealer Fields
            filteredDealers.forEach((dealer, index) => {
                const dealerNum = index + 1;
                hubSpotFormSection.querySelector(`input[name="dealer_company_name_${dealerNum}"]`).value = getValueOrPlaceholder(dealer.name);
                hubSpotFormSection.querySelector(`input[name="dealer_address_${dealerNum}"]`).value = getValueOrPlaceholder(dealer.address);
                hubSpotFormSection.querySelector(`input[name="dealer_phone_${dealerNum}"]`).value = getValueOrPlaceholder(dealer.phone);
                hubSpotFormSection.querySelector(`input[name="dealer_website_${dealerNum}"]`).value = getValueOrPlaceholder(dealer.website);
                hubSpotFormSection.querySelector(`input[name="dealer_distance_${dealerNum}"]`).value = getValueOrPlaceholder(dealer.distance);
            });

            // const hubSpotFormEntries = Object.fromEntries(new FormData(hubSpotForm));
            // console.log("Final form data before submission:", hubSpotFormEntries);
            hubSpotForm.submit();
        }

    }

}

initializeSizeSection();



